import type { CardEntryGroup } from '../../model/types';
import { useBacklogSelector } from '../index';
import { makeGetAllAttachedToParentCardGroupEntries } from '../selectors/cards';

export const useAllCardGroups = () => {
	const allCardGroups: CardEntryGroup[] = useBacklogSelector(
		makeGetAllAttachedToParentCardGroupEntries,
	)();

	return allCardGroups;
};
